import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
  signal,
} from '@angular/core';
import {
  modelTypeEnum,
  models,
  priceTypeEnum,
} from '../../model/standard-quote.model';
import { StandardQuoteService } from '../../standard-quote-service.service';
import { FileType, SubBrandService } from '@app/services/subbrand.service';
import { productTypeEnum } from '@app/pages/quote/open-quote/model/open-quote.model';
import { vehicles } from 'assets/files/vehicles';

@Component({
  template: ""
})
export class ModelsViewWrapperComponent implements OnInit {
  private quoteService = inject(StandardQuoteService);
  private subBrandService = inject(SubBrandService);
  subBrandImg = signal('');

  ngOnInit() {
    if (this.model) {
      this.getFile(this.model?.subBrand?.id || 0);
    }
  }

  getFile(id: number) {
    if (id === 0) return;
    this.subBrandService
      .getAttachmentByElementId(id, FileType.SUB_BRAND)
      .subscribe({
        next: (response: any) => {
          if (response.data.length > 0) {
            const row = response.data[0];
            this.subBrandImg.set(row.publicUrl || row.urlSource || '');
          } else {
            switch (this.model?.modelType?.toUpperCase()) {
              case productTypeEnum.accesorios:
                this.subBrandImg.set(vehicles.accesorios);
                break;
              case productTypeEnum.vanes:
                this.subBrandImg.set(vehicles.sprinter);
                break;
              case productTypeEnum.autobuses:
                this.subBrandImg.set(vehicles.autobus);
                break;
              case productTypeEnum.camiones:
                this.subBrandImg.set(vehicles.camion);
                break;
              case productTypeEnum.tractos:
                this.subBrandImg.set(vehicles.cascadia);
                break;
              case productTypeEnum.nonDamiler:
                this.subBrandImg.set(vehicles.nondaimler);
                break;
              default:
                this.subBrandImg.set('');
                break;
            }
          }
        },
        error: (error) => {
          if (error.status === 404) {
            return;
          }
          switch (this.model?.modelType?.toUpperCase()) {
            case productTypeEnum.accesorios:
              this.subBrandImg.set(vehicles.accesorios);
              break;
            case productTypeEnum.vanes:
              this.subBrandImg.set(vehicles.sprinter);
              break;
            case productTypeEnum.autobuses:
              this.subBrandImg.set(vehicles.autobus);
              break;
            case productTypeEnum.camiones:
              this.subBrandImg.set(vehicles.camion);
              break;
            case productTypeEnum.tractos:
              this.subBrandImg.set(vehicles.cascadia);
              break;
            case productTypeEnum.nonDamiler:
              this.subBrandImg.set(vehicles.nondaimler);
              break;
            default:
              this.subBrandImg.set('');
              break;
          }
        },
      });
  }

  getClassification(classification: boolean) {
    if (classification) {
      return 'Nuevo';
    } else if (!classification) {
      return 'Usado';
    } else {
      return '';
    }
  }

  getModel(modelType: modelTypeEnum) {
    if (modelType == modelTypeEnum.accesorios) {
      return 'Accesorios';
    } else if (modelType == modelTypeEnum.autobuses) {
      return 'Autobuses';
    } else if (modelType == modelTypeEnum.camiones) {
      return 'Camiones';
    } else if (modelType == modelTypeEnum.tractos) {
      return 'Tractos';
    }
    return '';
  }

  getPriceType(priceType: priceTypeEnum) {
    return 'Precio valor comercial';
  }

  getModelNameWithCode(model: any) {
    const codePart = model?.modelCode ?? '';
    const pattern = new RegExp(`\\|\\s*MB.*$`);
    const exactlyPattern = new RegExp(`\\s*${codePart}\\s*$`);

    let labelWithoutCode = model?.name?.replace?.(pattern, '')?.trim?.() ?? '';
    labelWithoutCode = labelWithoutCode.replace(exactlyPattern, '');
    return `${labelWithoutCode} | ${codePart}`;
  }

  get model() : models | undefined {
    return this.quoteService.formData?.model;
  }
  get quantiyForm() : number {
    const qty = this.quoteService.formData?.quantity;
    return qty && qty >= 1 ? qty : 1;
  }
}
